import { Routes } from '@angular/router';
import { LayoutComponent } from '@pxl/core/components/layout/layout.component';
import { AuthenticatedGuard } from '@pxl/core/guards/authenticated.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'login', redirectTo: '/auth/login', pathMatch: 'full' },
      {
        canActivate: [AuthenticatedGuard],
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
      },
      {
        canActivate: [AuthenticatedGuard],
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule)
      },
      {
        path: 'health-check',
        redirectTo: '/dashboard/healthcheck',
        pathMatch: 'full'
      },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      { path: '**', redirectTo: 'dashboard' }
    ]
  }
];
